import { useState, useEffect, useContext } from 'react';
import { Table, Button, Spin, message } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { CommonContext } from '../../Context';
import dayjs from 'dayjs';

const ReportHistory = () => {
  const commonContext = useContext(CommonContext);
  const buyerId = commonContext?.common?.buyerId;
  const [loading, setLoading] = useState(false);
  const [reportHistoryData, setReportHistoryData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [sorter, setSorter] = useState(null);

  const columns = [
    {
      title: 'Report Type',
      dataIndex: 'reportType',
      key: 'ReportType',
      sorter: true,
    },
    {
      title: 'Analysis Period',
      key: 'analysisPeriod',
      children: [
        {
          title: 'From',
          dataIndex: 'fromDate',
          key: 'FromDate',
          render: (_val, record) => (record.fromDate ? dayjs(record.fromDate).format(constants.DateFormat2) : ''),
          sorter: true,
        },
        {
          title: 'To',
          dataIndex: 'toDate',
          key: 'ToDate',
          render: (_val, record) => (record.toDate ? dayjs(record.toDate).format(constants.DateFormat2) : ''),
          sorter: true,
        },
      ],
    },
    {
      title: 'View Report',
      dataIndex: 'analysisDetails',
      key: 'viewReport',
      align: 'center',
      render: (_val, record) => (
        <Button
          type="text"
          icon={<EyeOutlined className="text-slate-600" />}
          onClick={() => window.open(`/view-report/${record.id}`, '_blank')}
        />
      ),
    },
  ];

  const fetchReportHistory = async ({ current = 1, pageSize = 10, sortField = null, sortOrder = 'ascend' } = {}) => {
    if (!buyerId) return;
    setLoading(true);
    let url = `${WebLinks.GetAnalysisReportHistory}${buyerId}&limit=${pageSize}&pageNo=${current}`;
    if (sortField) {
      const sortDesc = sortOrder === 'descend' ? 'true' : 'false';
      url += `&sortBy=${sortField}&sortDesc=${sortDesc}`;
    }
    try {
      const response = await APIUtils.apiCall('GET', url);
      if (!response.isCatch && response.resultObj) {
        const rows = response.resultObj.data || [];
        const total = response?.resultObj?.getCount || 0;
        setReportHistoryData(rows);
        setPagination({ current, pageSize, total });
      } else {
        message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
    } catch (err) {
      message.error(constants.ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportHistory({ current: pagination.current, pageSize: pagination.pageSize, sortField: sorter?.field, sortOrder: sorter?.order });
  }, [buyerId]);

  const handleTableChange = (pag, _filters, sort) => {
    const newSorter = sort && sort.field ? { field: sort.field, order: sort.order } : null;
    setSorter(newSorter);
    fetchReportHistory({ current: pag.current, pageSize: pag.pageSize, sortField: newSorter?.field, sortOrder: newSorter?.order });
  };

  return (
    <div>
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={reportHistoryData}
            pagination={{ current: pagination.current, pageSize: pagination.pageSize, total: pagination.total }}
            onChange={handleTableChange}
            className="report-history-table custom-table"
            showSizeChanger
            pageSizeOptions={['10', '25', '50', '100']}
          />
        </Spin>

      </div>
    </div>
  );
};
export default ReportHistory;
